export default __webpack_public_path__ + "08690111f6525320cefb376a6023470b.svg";